import { Slider } from '@mui/material';
import React from 'react';

type Props = {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  min?: number;
  max?: number;
};

const SoundSlider = ({
  value,
  onChange,
  disabled = false,
  min = 1,
  max = 100,
}: Props) => {
  return (
    <Slider
      size="small"
      value={value}
      onChange={(e, newValue) => {
        onChange(newValue as number);
      }}
      min={min}
      max={max}
      disabled={disabled}
      sx={{
        width: '130px',
        '& .MuiSlider-track': {
          color: '#3152E7',
          height: 5,
        },
        '& .MuiSlider-rail': {
          color: '#D9D9D9',
          height: 5,
        },
        '& .MuiSlider-thumb': {
          color: '#3152E7', // Колір повзунка (кружка)
        },
      }}
    />
  );
};

export default SoundSlider;
